import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-rose-50 pt-16 pb-8" dir="rtl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* عن Rose Mist */}
          <div>
            <img 
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/4dfdb1a34e845bad39d10d6fd0b0ed95.png" 
              alt="Rose Mist" 
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              وجهتك المثالية لمنتجات التجميل والعناية بالبشرة الفاخرة. نقدم لك أفضل المنتجات الطبيعية والآمنة لجمالك.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white rounded-full text-rose-400 hover:bg-rose-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white rounded-full text-rose-400 hover:bg-rose-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white rounded-full text-rose-400 hover:bg-rose-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-white rounded-full text-rose-400 hover:bg-rose-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* روابط سريعة */}
          <div>
            <h4 className="text-base font-semibold text-gray-800 mb-4">روابط سريعة</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">من نحن</Link></li>
              <li><Link to="/shop" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">المتجر</Link></li>
              <li><Link to="/blog" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">المدونة</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">تواصل معنا</Link></li>
            </ul>
          </div>

          {/* الفئات */}
          <div>
            <h4 className="text-base font-semibold text-gray-800 mb-4">الفئات</h4>
            <ul className="space-y-2">
              <li><Link to="/skincare" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">العناية بالبشرة</Link></li>
              <li><Link to="/makeup" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">المكياج</Link></li>
              <li><Link to="/bodycare" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">العناية بالجسم</Link></li>
              <li><Link to="/haircare" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">العناية بالشعر</Link></li>
              <li><Link to="/fragrance" className="text-sm text-gray-600 hover:text-rose-400 transition-colors">العطور</Link></li>
            </ul>
          </div>

          {/* معلومات التواصل */}
          <div>
            <h4 className="text-base font-semibold text-gray-800 mb-4">تواصل معنا</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-mail-line text-rose-400 mt-0.5"></i>
                <span>info@rosemist.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-rose-400 mt-0.5"></i>
                <span>+966 50 123 4567</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line text-rose-400 mt-0.5"></i>
                <span>الرياض، المملكة العربية السعودية</span>
              </li>
            </ul>
          </div>
        </div>

        {/* الحقوق */}
        <div className="border-t border-rose-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2025 Rose Mist. جميع الحقوق محفوظة
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-gray-500 hover:text-rose-400 transition-colors">سياسة الخصوصية</a>
            <a href="#" className="text-sm text-gray-500 hover:text-rose-400 transition-colors">الشروط والأحكام</a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-rose-400 transition-colors">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
